import { Routes } from '@angular/router';
import { NotFoundComponent } from './not-found/not-found.component';

// *******************************************************************************
// Layouts

import { Layout2Component } from './layout/layout-2/layout-2.component';
import { LayoutBlankComponent } from './layout/layout-blank/layout-blank.component';
import { AppGuard } from './app.guard';

export const ROUTES: Routes = [
  {
    path: '',
    //redirectTo: 'home',
    //redirectTo: 'checkout',
    //redirectTo: 'teste',
    redirectTo: 'black-week',
    pathMatch: 'full'
  },
  // {
  //   path: 'auth',
  //   component: LayoutBlankComponent,
  //   loadChildren: () => import('./view/public/public.modulo').then(m => m.PagesPublicModule),
  // },
  {
    path: 'checkout',
    component: LayoutBlankComponent,
    loadChildren: () => import('./view/checkout/checkout.modulo').then(m => m.PagesCheckoutModule),
  },
  {
    path: 'black-week',
    component: LayoutBlankComponent,
    loadChildren: () => import('./view/black-week/checkout.modulo').then(m => m.PagesCheckoutModule),
  },
  // {
  //   path: '',
  //   component: Layout2Component,
  //   canActivate: [AppGuard],
  //   children: [
  //     // { path: 'dashboards', loadChildren: () => import('./+dashboards/dashboards.module').then(m => m.DashboardsModule), }
  //     { path: '', loadChildren: () => import('./view/main/main.module').then(m => m.MainModule), }
  //   ]
  // },
  {
    path: "**",
    redirectTo: ""
  },
  // 404 Not Found page
  { path: '**', component: NotFoundComponent }
];
